import { render, staticRenderFns } from "./ShareList.vue?vue&type=template&id=13a6b535&scoped=true"
import script from "./ShareList.vue?vue&type=script&lang=js"
export * from "./ShareList.vue?vue&type=script&lang=js"
import style0 from "./ShareList.vue?vue&type=style&index=0&id=13a6b535&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a6b535",
  null
  
)

export default component.exports